import { useMutation } from 'react-query';
import { toast } from 'components/Shared/Toast';
import { useTranslation } from 'react-i18next';

import { fetcher } from 'api/client';
import { templateAction } from 'api/actions/templates';


export default function useTemplateAction(templateId, options = {}) {
    const { t } = useTranslation();

    const mutateTemplateAction = useMutation((data) => fetcher(templateAction(templateId, data.action, data.payload, data.config)), {
      ...options,
      onError: (error) => {
        toast.error(t(`errors.${error.message}`, t('errors.GeneralError')))
        if(options && options.onError) options.onError(error)
      }
    })



    return mutateTemplateAction
}